import { useId } from 'react';
import PropTypes from 'prop-types';

const AISearchIcon = ({
  size = 22,
  strokeWidth,
  className = '',
  title,
  ...rest
}) => {
  const reactId = useId();
  const maskId = `ai-search-mask-${reactId.replace(/[^a-zA-Z0-9]/g, '')}`;

  const effectiveStrokeWidth =
    strokeWidth ?? Math.max(1, Number(size) / 11);

  const ariaProps = title
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': true, focusable: false };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={effectiveStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...ariaProps}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect x="0" y="0" width="24" height="24" fill="white" />
          <circle cx="18" cy="6" r="4.5" fill="black" />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <circle cx="10" cy="10" r="6" />
        <path d="m20 20-3.5-3.5" />
      </g>
      <path
        d="M18 2.5l-.74 2.26a.78.78 0 0 1-.5.5L14.5 6l2.26.74a.78.78 0 0 1 .5.5L18 9.5l.74-2.26a.78.78 0 0 1 .5-.5L21.5 6l-2.26-.74a.78.78 0 0 1-.5-.5z"
        fill="currentColor"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

AISearchIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  title: PropTypes.string,
};

export default AISearchIcon;
